import React, { useRef, useState } from "react";
import { MaleModel3D } from "../Common/MaleModel/MaleModel3D";
import { useAnimate } from "framer-motion";
import { title } from "framer-motion/client";

// default image...
import ArmSSimg from "../../assets/images/ArmSSImg.png";
import UpperBackSSimg from "../../assets/images/UpperBackSSImg.png";
import LowerBackSSimg from "../../assets/images/LowerBackSSImg.png";
import MidBackSSimg from "../../assets/images/MidBackSSImg.png";
import NeckSSimg from "../../assets/images/ScreenShortNeck.png";
import ShoulderSSimg from "../../assets/images/ShoulderSSImg.png";
import LegsSSimg from "../../assets/images/LegsSSImg.png";
import ThighSSimg from "../../assets/images/ThighSSImg.png";

export const PainLocation = ({
  setSelectedPainLocation,
  elementRef,
  setScreenshot,
  setSelectedLocationMulti,
  selectedLoactionMulti,
  screenshot,
  selectedLoaction,
  setSelectedLocation,
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [takeScreenShort, setTakeScreenShort] = useState("");
  const [scope, animate] = useAnimate();
  const [currentPainLocationChoosen, setCuurentPainLocationChoosen] = useState({
    title: "",
    cameraPosition: [5, 10, 10],
    distance: 5.5,
    locationTitle: "",
    width: "",
    height: "",
    top: "",
    left: "",
  });

  const allPainLocation = [
    {
      title: "Neck",
      cameraPosition: [-5, 600, -140],
      distance: 2.7,

      width: "30vw",
      height: "10vw",
      top: "-2vw",
      left: "-20%",
    },
    {
      title: "Lower Back",
      cameraPosition: [-2, 50, -100],
      distance: 1.8,

      width: "30vw",
      height: "10vw",
      top: "-2vw",
      left: "-20%",
    },
    {
      title: "Mid Back",
      cameraPosition: [0, 45, -50],
      distance: 2.8,
      width: "30vw",
      height: "12vw",
      top: "-2vw",
      left: "-20%",
    },
    {
      title: "Upper Back",
      cameraPosition: [0, 70, -40],
      distance: 3.5,
      width: "30vw",
      height: "10vw",
      top: "-2vw",
      left: "-20%",
    },
    {
      title: "Shoulder",
      cameraPosition: [500, 750, -140],
      distance: 2.5,
      width: "30vw",
      height: "12vw",
      top: "-2vw",
      left: "-20%",
    },
    {
      title: "Arms",
      cameraPosition: [500, 300, -140],
      distance: 2.5,

      width: "25vw",
      height: "15vw",
      top: "2vw",
      left: "-30%",
    },
    {
      title: "Legs",
      cameraPosition: [280, -500, -30],
      distance: 2.5,

      width: "30vw",
      height: "20vw",
      top: "2vw",
      left: "-20%",
    },
    {
      title: "Thigh",
      cameraPosition: [280, -150, 200],
      distance: 2,

      width: "30vw",
      height: "20vw",
      top: "2vw",
      left: "-20%",
    },
    // { title: "Enter Manually", cameraPosition: [5, 10, 10], distance: 5.5 },
  ];

  const handleHightlightPart = async (top, left, height, width) => {
    animate(
      "#heighLighter__mainWrapper",
      {
        left: left,
        top: top,
      },
      {
        duration: 1,
        ease: "backInOut",
      }
    );
    animate(
      "#lineSVG",
      {
        width: width,
        height: height,
      },
      {
        duration: 1,
        ease: "backInOut",
      }
    );

    animate(
      "#painLocationLine",
      {
        pathLength: [0, 1],
      },
      {
        duration: 1,
        ease: "linear",
        delay: 0.2,
      }
    );
    await animate(
      "#painLocationTitle",
      {
        opacity: [0, 1],
      },
      {
        duration: 1,
        ease: "linear",
      }
    );
  };

  const heighLightIfSelected = (location, prevData) => {
    // console.log(prevData,'158');
    if (prevData) {
      const getLastLocation = prevData[prevData.length - 2];

      if (!getLastLocation) {
        setCuurentPainLocationChoosen({
          title: "Enter Manually",
          cameraPosition: [5, 10, 10],
          distance: 5.5,
        });

        setSelectedPainLocation({
          painLocation: "Enter Manually",
          cameraPosition: [5, 10, 10],
          distance: 5.5,
        });
        return;
      }
      const getPreviousLocation = allPainLocation.filter(
        (painLocation) => painLocation.title === getLastLocation
      );

      setCuurentPainLocationChoosen(...getPreviousLocation);
      setSelectedPainLocation({
        painLocation: getPreviousLocation[0].title
          ? getPreviousLocation[0].title
          : getLastLocation,
        cameraPosition: getPreviousLocation[0].cameraPosition,
        distance: getPreviousLocation[0].distance,
      });
      handleHightlightPart(
        getPreviousLocation[0].top,
        getPreviousLocation[0].left,
        getPreviousLocation[0].height,
        getPreviousLocation[0].width
      );
      return;
    }

    setCuurentPainLocationChoosen(location);
    setSelectedPainLocation({
      painLocation: location.title,
      cameraPosition: location.cameraPosition,
      distance: location.distance,
    });
    handleHightlightPart(
      location.top,
      location.left,
      location.height,
      location.width
    );
  };

  const handleOnClick = (location) => {
    setSelectedLocation((prevData) => {
      // Check if the title exists
      const exists = prevData.includes(location.title);

      // If it exists, remove it and add the new one
      if (exists) {
        const result = [...prevData.filter((item) => item !== location.title)];
        heighLightIfSelected(location, prevData);
        // return [...prevData.filter((item) => item !== location.title)];
        return result;
      }

      heighLightIfSelected(location);
      // If it doesn't exist, just add it
      return [...prevData, location.title];
    });

    setSelectedLocationMulti((prevData) => {
      // Ensure prevData is an array to prevent undefined errors
      const safePrevData = Array.isArray(prevData) ? prevData : [];

      // Remove any existing item with the same title
      const filteredData = safePrevData.filter((item) => {
        return item.title !== location.title;
      });

      // If filteredData length equals prevData length, no duplicate was found
      if (filteredData.length === safePrevData.length) {
        // No duplicate found, add new item
        setPatientMedicationInfo({
          ...patientMedicationInfo,
          selectedPainArea: [
            ...safePrevData,
            {
              title: location.title,
              SSimage: screenshot || null,
              painLevel: "",
              side:''
            },
          ],
        });
        return [
          ...safePrevData,
          {
            title: location.title,
            SSimage: screenshot || null,
            painLevel: "",
          },
        ];
      }

      setPatientMedicationInfo({
        ...patientMedicationInfo,
        selectedPainArea: filteredData,
      });
      // If we get here, a duplicate was removed, return filteredData
      return filteredData;
    });
  };

  const handleDefaultImg = (curPainLoaction) => {
    if (curPainLoaction === "Arms") {
      return ArmSSimg;
    }
    if (curPainLoaction === "Mid Back") {
      return MidBackSSimg;
    }
    if (curPainLoaction === "Upper Back") {
      return UpperBackSSimg;
    }
    if (curPainLoaction === "Lower Back") {
      return LowerBackSSimg;
    }
    if (curPainLoaction === "Neck") {
      return NeckSSimg;
    }
    if (curPainLoaction === "Shoulder") {
      return ShoulderSSimg;
    }
    if (curPainLoaction === "Thigh") {
      return ThighSSimg;
    }
    if (curPainLoaction === "Legs") {
      return LegsSSimg;
    }
  };

  return (
    <>
      <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between gap-4 mb-8">
        <div className="flex-1 flex justify-start items-start px-4 py-2 relative">
          <div className="absolute top-0 -left-[20vw] w-full h-full gradientBg" />
          <div className="2xl:w-[70%] xl:w-[70%] lg:w-[70%] md:w-[70%] w-[100%] relative z-20">
            <h2 className="text-[#333333] font-[600] font-mainFont 2xl:text-[2.7dvw] xl:text-[2.7dvw] lg:text-[2.7dvw] md:text-[2.7dvw] text-[5dvw] mb-4">
              Select Pain Area
            </h2>
            <div className="2xl:p-5 xl:p-5 lg:p-5 md:p-5 p-2   rounded-lg w-full grid grid-cols-2 2xl:gap-3 xl:gap-3 lg:gap-3 md:gap-3 gap-1.5 ">
              {allPainLocation.map((location, id) => (
                <button
                  key={id}
                  onClick={() => {
                    handleOnClick(location);
                  }}
                  className={` py-2.5 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw] bg-baseColor border-none outline-none rounded-full w-full font-mainFont font-[600] text-[#000]    btnGraident2 transition-all duration-100 ease-in ${
                    selectedLoaction.includes(location.title) &&
                    "text-white BTNGradientBg"
                  }`}
                >
                  {location.title}
                </button>
              ))}
            </div>

            {selectedLoactionMulti.length > 0 && (
              <div className="mt-8">
                <h3 className="font-[600] text-[#333333] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[4dvw]">
                  Selected Pain Area's
                </h3>
                <div className="grid grid-cols-3 gap-2.5 mt-6">
                  {selectedLoactionMulti.map((cur, id) => (
                    <div
                      key={id}
                      className="bg-[#f0f0f0] border border-[#d4d4d4] flex justify-center items-center p-2 rounded-xl"
                    >
                      <div className="w-full h-full">
                        <img
                          src={handleDefaultImg(cur.title)}
                          className="h-auto"
                          alt="default-image"
                        />

                        <h3 className="text-center font-semibold text-[.9dvw]">{cur.title}</h3>
                        {cur.title === "Lower Back" ||
                        cur.title === "Mid Back" ||
                        cur.title === "Upper Back" ? (
                          ""
                        ) : (
                          <div className="w-full my-2">
                            <select className="w-full rounded-sm border-none outline-none text-center px-1 py-.5 text-[">
                              <option value="left">Left</option>
                              <option value="right">Right</option>
                              <option value="both">Both</option>
                            </select>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          ref={elementRef}
          id="mobelWrapper"
          className="flex-1  flex justify-center items-center 2xl:h-[70vh] xl:h-[70vh] lg:h-[70vh] md:h-[70vh] h-[30vh] relative"
        >
          <div
            ref={scope}
            className="flex-1  flex justify-center items-center 2xl:h-[70vh] xl:h-[70vh] lg:h-[70vh] md:h-[70vh] h-[50vh] relative"
          >
            <div
              id="heighLighter__mainWrapper"
              className={`absolute -top-[2vw] 2xl:inline lg:flex xl:inline md:inline hidden -left-[10%] z-20  ${
                currentPainLocationChoosen.title &&
                currentPainLocationChoosen.title !== "Enter Manually"
                  ? "opacity-100"
                  : "opacity-0"
              }`}
            >
              <h3
                id="painLocationTitle"
                className="font-[600] text-[1.5vw]  font-mainFont text-[#333333]"
              >
                {currentPainLocationChoosen.title}
              </h3>
              <svg
                width="268"
                height="150"
                viewBox="0 0 268 217"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[30vw] h-[8vw] rotate-180"
                id="lineSVG"
              >
                <path
                  opacity="0.6"
                  d="M0.888916 1H180.5L266.5 216.5"
                  stroke="#317BDB"
                  stroke-width="1.6708"
                  id="painLocationLine"
                />
              </svg>
            </div>
            <MaleModel3D
              cameraPosition={currentPainLocationChoosen.cameraPosition}
              distance={currentPainLocationChoosen.distance}
              takeScreenShort={takeScreenShort}
              setScreenshot={setScreenshot}
            />
          </div>
        </div>
      </div>
    </>
  );
};
